import React, { Component } from "react";
import { MessageType } from "constants/UserConstants";
import { BsSearch } from "react-icons/bs";
import { MdClear } from "react-icons/md";
import { debounce } from "lodash";
import PropTypes from "prop-types";

export default class SearchField extends Component {
  static propTypes = {
    conversation: PropTypes.object,
    olderConversations: PropTypes.array,
    onSearch: PropTypes.func.isRequired,
    onShowSearch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    conversation: {},
    olderConversations: [],
  };

  constructor() {
    super();
    this.searchInputRef = React.createRef();
    this.debouncedOnSearch = debounce(this.onSearch, 0.2);
    this.state = {
      showSearch: false,
      searchText: "",
    };
  }

  onSearch = () => {
    const { conversation, olderConversations } = this.props;
    const { messages } = conversation;
    const { searchText } = this.state;
    const allMessages = [];
    if (olderConversations) {
      olderConversations.forEach((conv) => {
        allMessages.push(conv.messages);
      });
    }
    allMessages.push(messages);
    const flatArrayOfAllMessages = [].concat.apply([], allMessages);

    const messagesWithText = flatArrayOfAllMessages.filter((msg) => {
      const isVideoWithCaption =
        msg.messageType === MessageType.VIDEO &&
        msg.message !== "" &&
        msg.message !== null;
      const isImageWithCaption =
        msg.messageType === MessageType.IMAGE &&
        msg.message !== "" &&
        msg.message !== null;

      return (
        msg.messageType === MessageType.TEXT ||
        msg.messageType === MessageType.DOCUMENT ||
        isVideoWithCaption ||
        isImageWithCaption ||
        msg.messageType === MessageType.LOCATION
      );
    });

    if (searchText.trim().length) {
      const highlightedMessages = messagesWithText.filter((msg) => {
        if (msg.messageType === MessageType.LOCATION) {
          return this.validateSearchForLocationMessage(msg, searchText);
        } else {
          return msg && msg.message
            ? msg.message.toLowerCase().includes(searchText.toLowerCase())
            : false;
        }
      });
      this.props.onSearch(highlightedMessages);
    } else {
      this.props.onSearch([]);
    }
  };

  validateSearchForLocationMessage = (msg, searchText) => {
    return (
      "Latitude".toLowerCase().includes(searchText.toLowerCase()) ||
      "Longitude".toLowerCase().includes(searchText.toLowerCase()) ||
      msg.latitude.toString().includes(searchText) ||
      msg.longitude.toString().includes(searchText) ||
      this.isLocationNamePresentAndMatchesWithSearchText(msg, searchText) ||
      this.isLocationAddressPresentAndMatchesWithSearchText(msg, searchText)
    );
  };

  isLocationNamePresentAndMatchesWithSearchText = (msg, searchText) => {
    return msg.locationName
      ? msg.locationName.toLowerCase().includes(searchText.toLowerCase())
      : false;
  };

  isLocationAddressPresentAndMatchesWithSearchText = (msg, searchText) => {
    return msg.address
      ? msg.address.toLowerCase().includes(searchText.toLowerCase())
      : false;
  };

  onSearchExpand = () => {
    this.searchInputRef.current.focus();
    this.setState({
      showSearch: true,
    });
    this.props.onShowSearch(true);
  };

  onSearchChange = (e) => {
    const searchText = e.target.value;
    this.setState(
      {
        searchText: searchText,
      },
      () => {
        this.debouncedOnSearch(searchText);
      }
    );
  };

  onSearchClear = () => {
    this.setState({
      showSearch: false,
      searchText: "",
    });
    this.props.onSearch([]);
    this.props.onShowSearch(false);
  };

  render() {
    const { showSearch, searchText } = this.state;

    return (
      <div className={`search-box`}>
        <BsSearch className="search-icon" onClick={this.onSearchExpand} />{" "}
        <input
          ref={this.searchInputRef}
          className="search-input"
          type="text"
          onChange={this.onSearchChange}
          value={searchText}
          placeholder="Search keywords..."
        />{" "}
        {showSearch ? (
          <MdClear
            className="search-clear"
            onClick={this.onSearchClear}
            size="1.5em"
          />
        ) : (
          ""
        )}{" "}
      </div>
    );
  }
}
